import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { BaseDialogActionData, ButtonColor, CommonActionKey } from "common";
import {
  DashboardActionData,
  DashboardActionSelectedValue,
  DrawFundsActionData,
} from "../../models/dashboard-actions.model";

@Component({
    selector: "ifm-draw-funds-dialog",
    templateUrl: "./draw-funds-dialog.component.html",
    styleUrls: ["./draw-funds-dialog.component.scss"],
    standalone: false
})
export class DrawFundsDialogComponent {
  actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.Cancel, label: 'Cancel', buttonColor: ButtonColor.Default },
    { actionKey: CommonActionKey.Ok, label: 'Ok', buttonColor: ButtonColor.Primary },
  ];
  selectedData: DashboardActionSelectedValue;

  constructor(
    public dialogRef: MatDialogRef<DrawFundsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DashboardActionData
  ) {}

  onSelectChange(data: DashboardActionSelectedValue): void {
    this.selectedData = data;
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    if (actionData.actionKey !== CommonActionKey.Ok) {
      this.dialogRef.close();
      return;
    }

    if (!this.selectedData.isValid) {
      return;
    }

    const data: DrawFundsActionData = {
      entityId: this.selectedData.entityId,
      loanId: this.selectedData.loanId,
      productCode: this.selectedData.productCode
    }

    this.dialogRef.close(data);
  }
}
